// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eY","advertDetailHeaderLocation__value":"c-m_eZ"};